// extracted by mini-css-extract-plugin
export default {"button":"index-module__button--xz7al","button__hidden":"index-module__button__hidden--gCL6s","button_wrapper":"index-module__button_wrapper--lap2L"};